import { render } from "./Teachers.vue?vue&type=template&id=01dc5b83&ts=true"
import script from "./Teachers.vue?vue&type=script&lang=ts"
export * from "./Teachers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__